import * as React from 'react';
import Page from '../containers/Page';
import TasksList  from '../containers/TasksList';

export default () => (
    <Page title="Focus">
     <TasksList focus />
    </Page>
)